"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openUpdateTypeModal = exports.openUpdateFooterModal = exports.openEmailCreationModal = exports.openSetBccEmailModal = exports.openResetSmtpTokenPasswordModal = exports.openMakeFooterDefaultModal = exports.openDeleteSmtpTokenModal = exports.openDeleteFooterModal = exports.openCreateTypeModal = exports.openCreateSmtpTokenModal = exports.openCreateFooterModal = exports.closeModal = exports.ModalActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var ModalActionTypes = (0, _namespacedKeyMirror.default)({
  CLOSE_MODAL: null,
  OPEN_CREATE_FOOTER_MODAL: null,
  OPEN_CREATE_SMTP_TOKEN_MODAL: null,
  OPEN_CREATE_TYPE_MODAL: null,
  OPEN_DELETE_FOOTER_MODAL: null,
  OPEN_DELETE_SMTP_TOKEN_MODAL: null,
  OPEN_MAKE_FOOTER_DEFAULT_MODAL: null,
  OPEN_RESET_SMTP_TOKEN_PASSWORD_MODAL: null,
  OPEN_SET_BCC_EMAIL_MODAL: null,
  OPEN_UPDATE_FOOTER_MODAL: null,
  OPEN_EMAIL_CREATION_MODAL: null,
  OPEN_UPDATE_TYPE_MODAL: null
}, 'email');
exports.ModalActionTypes = ModalActionTypes;
var closeModal = (0, _fluxActions.createAction)(ModalActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;
var openCreateFooterModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_CREATE_FOOTER_MODAL);
exports.openCreateFooterModal = openCreateFooterModal;
var openCreateSmtpTokenModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_CREATE_SMTP_TOKEN_MODAL);
exports.openCreateSmtpTokenModal = openCreateSmtpTokenModal;
var openCreateTypeModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_CREATE_TYPE_MODAL);
exports.openCreateTypeModal = openCreateTypeModal;
var openDeleteFooterModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_DELETE_FOOTER_MODAL, (0, _actions.mapPayloadTo)('id'));
exports.openDeleteFooterModal = openDeleteFooterModal;
var openDeleteSmtpTokenModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_DELETE_SMTP_TOKEN_MODAL, (0, _actions.mapPayloadTo)('id'));
exports.openDeleteSmtpTokenModal = openDeleteSmtpTokenModal;
var openMakeFooterDefaultModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_MAKE_FOOTER_DEFAULT_MODAL, (0, _actions.mapPayloadTo)('id'));
exports.openMakeFooterDefaultModal = openMakeFooterDefaultModal;
var openResetSmtpTokenPasswordModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_RESET_SMTP_TOKEN_PASSWORD_MODAL, (0, _actions.mapPayloadTo)('id'));
exports.openResetSmtpTokenPasswordModal = openResetSmtpTokenPasswordModal;
var openSetBccEmailModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_SET_BCC_EMAIL_MODAL);
exports.openSetBccEmailModal = openSetBccEmailModal;
var openEmailCreationModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_EMAIL_CREATION_MODAL, (0, _actions.mapPayloadTo)('modalData'));
exports.openEmailCreationModal = openEmailCreationModal;
var openUpdateFooterModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_UPDATE_FOOTER_MODAL, (0, _actions.mapPayloadTo)('id'));
exports.openUpdateFooterModal = openUpdateFooterModal;
var openUpdateTypeModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_UPDATE_TYPE_MODAL, (0, _actions.mapPayloadTo)('id'));
exports.openUpdateTypeModal = openUpdateTypeModal;